// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icp__input[data-v-512dc202]{height:25px;border-radius:15px;width:40px;border:none;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;padding:0}.icp__input[data-v-512dc202]::-webkit-color-swatch-wrapper{padding:0}.icp__input[data-v-512dc202]::-webkit-color-swatch{border:none;border-radius:15px}.icp__input[data-v-512dc202]::-moz-color-swatch{border:none;border-radius:15px}", ""]);
// Exports
module.exports = exports;
